import SliderWithPercent from "./SliderWithPercent.jsx";

export default SliderWithPercent;



// WEBPACK FOOTER //
// ./src/components/common/sliderWithPercent/index.js